import script from "./FormulasIngredientMeth.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredientMeth.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredientMeth.vue?vue&type=style&index=0&id=1fb1f1f7&lang=scss"

const __exports__ = script;

export default __exports__